export enum OutsideTrainingEnum {
    Mental = 'Mental',
    Social = 'Social',
    Stress = 'Stress',
    Physical = 'Physical',
}
